import { Helmet } from 'react-helmet';
import { Box, Container, Typography } from '@material-ui/core';
import SettingsNotifications from 'src/components/settings/SettingsNotifications';
import SettingsPassword from 'src/components/settings/SettingsPassword';

//My Components
import TreeView from 'src/testComponents/treeView';
import BackD from 'src/testComponents/backdrop';



const SettingsView = () => (
  <>

    <Helmet>
      <title>Settings | Transac</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth="lg">
      <Typography variant="h3">QUESTIONNAIRE</Typography>
      <br/>
       <TreeView/>
      </Container>
    </Box>
  </>
);

export default SettingsView;
